import { onMounted } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useOnUserLogin from "@/hooks/useOnUserLogin";
import providers from "@/lib/api";
import { base64UrlToUint8Array } from "@/lib/encryptionHelper";
import config from "@/config";

export default function useWebPushNotifications() {
  const { authUser } = useAuthUser();

  const initPushRequest = async () => {
    if (Notification.permission === "denied") {
      return;
    }
    if (Notification.permission === "default") {
      const requestedPermission = await Notification.requestPermission();
      if (requestedPermission !== "granted") {
        return;
      }
    }
    const reg = await navigator.serviceWorker.ready;
    const currentSubscription = await reg.pushManager.getSubscription();
    if (currentSubscription !== null) {
      return;
    }
    const unit8Buffer = base64UrlToUint8Array(config.webPushNotificationsPublicKey);
    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: unit8Buffer,
    });
    const subscriptionsJson = subscription.toJSON();
    await providers.PushNotificationsProvider.webPushNotificationsSubscribe({
      data: {
        endpoint: subscriptionsJson.endpoint ?? "",
        p256dh: subscriptionsJson.keys?.p256dh ?? "",
        auth: subscriptionsJson.keys?.auth ?? "",
      },
    });
  };

  useOnUserLogin(() => {
    if (config.webPushNotificationsPublicKey && "serviceWorker" in navigator) {
      initPushRequest();
    }
  });

  onMounted(() => {
    if (config.webPushNotificationsPublicKey && "serviceWorker" in navigator && authUser.value) {
      window.addEventListener("click", initPushRequest, { once: true });
    }
  });
}
